module.exports = __webpack_public_path__ + "img/partner21.2d529fef.png";